module.exports = __webpack_public_path__ + "img/有风.e6e29d62.png";